import { useQuery, useMutation } from "react-query";
import {
  getSFTPConnectionData,
  deleteSFTPConnectionData,
  getSFTPJobData,
  deleteSFTPJobData,
  getSFTPLogData,
  createSFTPConnectionData,
  updateSFTPConnectionData,
  createSFTPJobData,
  updateSFTPJobData,
} from "../api/sftp";

// Get sftp connection react query hook
export const useGetConnections = (options = {}) => {
  return useQuery("SFTPConnectionData", () => getSFTPConnectionData(), {
    ...options,
  });
};

// Delete sftp connection react query hook
export const useDeleteConnection = (options) => {
  return useMutation(deleteSFTPConnectionData, options);
};
// Get sftp job react query hook
export const useGetJobs = () => {
  return useQuery("SFTPJobData", () => getSFTPJobData());
};

// Delete sftp job react query hook
export const useDeleteJob = (options) => {
  return useMutation(deleteSFTPJobData, options);
};

// Get sftp job react query hook
export const useGetSFTPLogs = (Logdata, logOptions) => {
  return useQuery(["getSFTPLogData", Logdata], () => getSFTPLogData(Logdata), {
    ...logOptions,
  });
};

// Create sftp connection react query hook
export const useCreateConnection = (options) => {
  return useMutation(createSFTPConnectionData, options);
};

// Update sftp connection react query hook
export const useUpdateConnection = (options) => {
  return useMutation(updateSFTPConnectionData, options);
};

// Create sftp job react query hook
export const useCreateSFTPJobData = (options) => {
  return useMutation(createSFTPJobData, options);
};
// Update sftp job react query hook
export const useUpdateSFTPJobData = (options) => {
  return useMutation(updateSFTPJobData, options);
};

export default {
  useGetConnections,
  useDeleteConnection,
  useGetJobs,
  useDeleteJob,
  useCreateSFTPJobData,
  useUpdateSFTPJobData,
};
